export default [
    {
        path: "/report/training/ipft",
        component: () => import("../Components/Ipft.vue"),
        name: "report-training-ipft",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/ipft-summary",
        component: () => import("../Components/IpftSummary.vue"),
        name: "report-training-ipft-summary",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/ipft-detail-result",
        component: () => import("../Components/IpftDetailResult.vue"),
        name: "report-training-ipft-detail-result",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/ret",
        component: () => import("../Components/Ret.vue"),
        name: "report-training-ret",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/speed-march",
        component: () => import("../Components/SpeedMarch.vue"),
        name: "report-training-speed-march",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/grenade-firing",
        component: () => import("../Components/GrenadeFiring.vue"),
        name: "report-training-grenade-firing",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/training/trg-cycle",
        component: () => import("../Components/Trg.vue"),
        name: "report-training-trg-cycle",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/user-training",
        component: () => import("../Components/UserTraining.vue"),
        name: "report-user-training",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/firing-training-summary",
        component: () => import("../Components/FiringTrainingSummary.vue"),
        name: "report-firing-training-summary",
        meta: {
            requiresAuth: true,
        },
    },
];
